import React from 'react';
import { Link } from 'react-router-dom';
import { WA_CONTACTO } from '../constants';
import PapelPicado, { BanderaMX } from './PapelPicado';

const Contacto: React.FC = () => {
  return (
    <footer className="text-white font-[Arial,sans-serif] bg-gradient-brand">
      <PapelPicado />
      <div className="px-5 pt-6 pb-5">
        <div className="flex flex-col md:flex-row items-start justify-between max-w-[1000px] mx-auto gap-5">
          {/* Logo y slogan */}
          <div className="flex-1 mb-5">
            <img src="/mamas/logo-s.png" alt="El Chel Logo" className="w-[170px] mb-2.5" />
            <p className="text-[clamp(16px,1.7vw,24px)] italic mb-2.5"><BanderaMX /> Desde 1978 — El sabor que no para</p>
          </div>

          {/* Sucursales y correo */}
          <div className="flex-1 mb-5">
            <h3 className="text-[clamp(20px,2vw,30px)] font-bold mb-2.5 text-[#ff6d00]">Sucursales</h3>
            <p>
              <Link to="/sucursales" className="text-white no-underline text-[clamp(16px,1.8vw,20px)] hover:text-[#ff6d00]">
                Ver todas las sucursales
              </Link>
            </p>
            <br />
            <p className="text-[clamp(16px,1.6vw,30px)] mt-1 text-[#ff6d00] font-bold">Correo General:</p>
            <p>
              <a href="mailto:elcheloficial@gmail.com" className="text-white no-underline text-[clamp(16px,1.8vw,20px)] hover:text-[#ff6d00]">
                elcheloficial@gmail.com
              </a>
            </p>
          </div>

          {/* Conócenos */}
          <div className="flex-1 mb-5">
            <h3 className="text-[clamp(20px,2vw,30px)] font-bold mb-2.5 text-[#ff6d00]">Conócenos</h3>
            <ul className="list-none p-0 m-0 space-y-1">
              <li><Link to="/nosotros" className="text-white no-underline text-[clamp(16px,1.8vw,20px)] hover:text-[#ff6d00]">Nosotros</Link></li>
              <li><Link to="/opiniones" className="text-white no-underline text-[clamp(16px,1.8vw,20px)] hover:text-[#ff6d00]">Opiniones</Link></li>
              <li><Link to="/terminos" className="text-white no-underline text-[clamp(16px,1.8vw,20px)] hover:text-[#ff6d00]">Términos y Condiciones</Link></li>
            </ul>
          </div>

          {/* Redes sociales */}
          <div className="flex-1 mb-5 text-center">
            <h3 className="text-[clamp(20px,2vw,30px)] font-bold mb-2.5 text-[#ff6d00]">Redes sociales</h3>
            <ul className="list-none p-0 m-0 flex justify-center gap-10 flex-wrap">
              {/* WhatsApp */}
              <li className="relative group mx-2.5">
                <a
                  aria-label="Whatsapp"
                  href={WA_CONTACTO}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative overflow-hidden flex justify-center items-center w-[clamp(50px,5vw,70px)] h-[clamp(50px,5vw,70px)] rounded-full text-[#ff6d00] bg-white transition-all duration-300 hover:text-white hover:shadow-lg"
                >
                  <div className="absolute bottom-0 left-0 w-full h-0 bg-[#ff6d00] transition-all duration-300 group-hover:h-full" />
                  <svg viewBox="0 0 24 24" className="relative z-10 w-7 h-7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                </a>
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 text-white px-2.5 py-1.5 rounded opacity-0 invisible transition-all duration-300 text-sm group-hover:opacity-100 group-hover:visible group-hover:-top-12 whitespace-nowrap">
                  Whatsapp
                </div>
              </li>

              {/* Facebook */}
              <li className="relative group mx-2.5">
                <a
                  aria-label="Facebook"
                  href="https://www.facebook.com/profile.php?id=61572273834288"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative overflow-hidden flex justify-center items-center w-[clamp(50px,5vw,70px)] h-[clamp(50px,5vw,70px)] rounded-full text-[#ff6d00] bg-white transition-all duration-300 hover:text-white hover:shadow-lg"
                >
                  <div className="absolute bottom-0 left-0 w-full h-0 bg-[#ff6d00] transition-all duration-300 group-hover:h-full" />
                  <svg viewBox="0 0 24 24" className="relative z-10 w-7 h-7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z" />
                  </svg>
                </a>
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 text-white px-2.5 py-1.5 rounded opacity-0 invisible transition-all duration-300 text-sm group-hover:opacity-100 group-hover:visible group-hover:-top-12 whitespace-nowrap">
                  Facebook
                </div>
              </li>

              {/* Instagram */}
              <li className="relative group mx-2.5">
                <a
                  aria-label="Instagram"
                  href="https://www.instagram.com/elchel_oficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative overflow-hidden flex justify-center items-center w-[clamp(50px,5vw,70px)] h-[clamp(50px,5vw,70px)] rounded-full text-[#ff6d00] bg-white transition-all duration-300 hover:text-white hover:shadow-lg"
                >
                  <div className="absolute bottom-0 left-0 w-full h-0 bg-[#ff6d00] transition-all duration-300 group-hover:h-full" />
                  <svg viewBox="0 0 16 16" className="relative z-10 w-7 h-7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </a>
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 text-white px-2.5 py-1.5 rounded opacity-0 invisible transition-all duration-300 text-sm group-hover:opacity-100 group-hover:visible group-hover:-top-12 whitespace-nowrap">
                  Instagram
                </div>
              </li>

              {/* TikTok */}
              <li className="relative group mx-2.5">
                <a
                  aria-label="TikTok"
                  href="https://www.tiktok.com/@elcheloficial"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative overflow-hidden flex justify-center items-center w-[clamp(50px,5vw,70px)] h-[clamp(50px,5vw,70px)] rounded-full text-[#ff6d00] bg-white transition-all duration-300 hover:text-white hover:shadow-lg"
                >
                  <div className="absolute bottom-0 left-0 w-full h-0 bg-[#ff6d00] transition-all duration-300 group-hover:h-full" />
                  <svg viewBox="0 0 24 24" className="relative z-10 w-7 h-7" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.77a4.85 4.85 0 0 1-1.01-.08z"/>
                  </svg>
                </a>
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 text-white px-2.5 py-1.5 rounded opacity-0 invisible transition-all duration-300 text-sm group-hover:opacity-100 group-hover:visible group-hover:-top-12 whitespace-nowrap">
                  TikTok
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer bottom */}
        <div className="mt-5 border-t border-[#ff6d00]/40 pt-2.5 text-center">
          <p className="text-[clamp(14px,1.4vw,20px)] text-white my-1">Términos y condiciones de nuestras redes</p>
          <p className="text-[clamp(14px,1.4vw,20px)] text-white my-1">Copyright 2026 El Chel</p>
        </div>
      </div>
    </footer>
  );
};

export default Contacto;
